import { getMfeConfig } from "@sinch/bus";
import type { MFE } from "@sinch/mfe-types";
import { importRemote } from "module-federation-import-remote";

// set in the template

const remoteEntryFileMatch = new RegExp(/\/(?!.*\/)(.*\.js.+)/);
export type MFELoader = {
  default: MFE;
};

export const loadMFE = async (scope: string, module: string): Promise<MFE> => {
  const mfe = await getMfeConfig(scope);

  if (!mfe) {
    throw new Error("No Config for that MFE: " + scope);
  }

  if (mfe.flags?.includes("esm")) {
    return import(/* webpackIgnore: true */ mfe.url + "/remoteEntry.js").then(
      (x) => x.default
    );
  }

  const remoteEntryFileName =
    remoteEntryFileMatch.exec(mfe.url)?.[1] || "remoteEntry.js";

  const mfeLoader = await importRemote<MFELoader>({
    url: remoteEntryFileName,
    scope,
    module,
    remoteEntryFileName,
    bustRemoteEntryCache: false,
  });

  return mfeLoader.default;
};
